<template>
    <div class="p-6 max-w-xl mx-auto text-center">
      <h2 class="text-2xl font-bold mb-4">🛠️ Migrar Imágenes de Productos</h2>
      <p class="text-gray-600 mb-4">Este proceso reubicará imágenes al path correcto por ID de producto.</p>
  
      <button
        @click="migrarImagenes"
        :disabled="migrando"
        class="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
      >
        {{ migrando ? 'Migrando...' : 'Ejecutar migración' }}
      </button>
  
      <p v-if="finalizado" class="mt-4 text-green-600 font-semibold">✅ Migración completada</p>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  import { db, storage } from '@/firebase'
  import { getDocs, collection, doc, updateDoc } from 'firebase/firestore'
  import { ref as sRef, uploadBytes, getDownloadURL } from 'firebase/storage'
  
  const migrando = ref(false)
  const finalizado = ref(false)
  
  const migrarImagenes = async () => {
    migrando.value = true
    const snap = await getDocs(collection(db, 'productos'))
  
    for (const d of snap.docs) {
      const prod = d.data()
  
      if (prod.imagePath?.includes(d.id)) continue
      if (!prod.imagenUrl) continue
  
      try {
        const response = await fetch(prod.imagenUrl)
        const blob = await response.blob()
  
        const newPath = `productos/${d.id}/main.jpg`
        const storageRef = sRef(storage, newPath)
        await uploadBytes(storageRef, blob)
        const newUrl = await getDownloadURL(storageRef)
  
        await updateDoc(doc(db, 'productos', d.id), {
          imagenUrl: newUrl,
          imagePath: newPath
        })
  
        console.log(`✅ Producto ${d.id} corregido`)
      } catch (err) {
        console.error(`❌ Error en producto ${d.id}:`, err)
      }
    }
  
    migrando.value = false
    finalizado.value = true
  }
  </script>
  